export default __webpack_public_path__ + "static/favicon-0523a43bd79d3db37c58b706588b497e.ico";